/* eslint-disable */
import styles from './index.module.scss'
import { Link, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { BreadcrumbArrow } from '../../../icons'
import { PageContext } from '../../../context/PageContextProvider'
import { SearchIcon } from '../../../icons'
import translate from '../../../utils/translate'

const Useful = ({ search = true }) => {
  const { language } = useContext(PageContext)
  const links = [
    { link: '/useful/news', name: translate.news?.[language] || 'Xəbərlər' },
    { link: '/useful/events', name: translate.events?.[language] || 'Tədbirlər' },
    { link: '/useful/training', name: translate.seminars?.[language] || 'Təlimlər' },
    { link: '/useful/calendar', name: translate.calendar?.[language] || 'Təqvim' },
    { link: '/useful/calculator', name: translate.calculator?.[language] || 'Kalkulyator' },
    { link: '/useful/currency', name: translate.currency?.[language] || 'Valyuta' },
  ]
  const location = useLocation()
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.breadcrumb}>
          <Link to={'/'}>{translate.home[language]}</Link>
          <BreadcrumbArrow />
          <Link to={'#'}>{translate.useful[language]}</Link>
        </div>
        <h1>{translate.useful[language]}</h1>
        {search && (
          <label className={styles.search}>
            <SearchIcon />
            <input type="text" placeholder="Search" />
          </label>
        )}
      </div>
      <ul>
        {links.map((item, i) => (
          <li
            className={
              location.pathname.includes(item.link) ? styles.active : ''
            }
          >
            <Link to={item.link}>{item.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
export default Useful
